export const host = import.meta.env.VITE_HOST ?? `https://${window.location.host}/`;
export const asset_host = import.meta.env.VITE_ASSETS_HOST ?? `https://${window.location.host}/debug/`;

export const minuteVersion = Math.floor(Date.now() / 1000 / 60);
export const urls = {
  changes: asset_host + "changes.json",
  lobby: asset_host + "lobby.json",
  tutorial: asset_host + "tutorial.json",
};

export default {
  urls
};